<script lang="ts">
    import InsightsGraph from '../InsightsGraph.svelte';
    import type {RouteMeasurements} from "../../models/route-measurements.model";
    
    export let measurementTimeStamps: Date[]
    export let measurementsForGraph: RouteMeasurements[]
    export let activeMeasurementProperty: string;
    export let showMeasurementPropertySelector: boolean;
</script>

<div class="graph-card">
    <InsightsGraph
        {activeMeasurementProperty}
        {measurementsForGraph}
        {measurementTimeStamps}
        {showMeasurementPropertySelector}
        showRouteFilter={false}   
    />
</div>

<style lang="scss">
    .graph-card {
        padding: 16px;
        overflow: hidden;
      height: 100%;
      min-height: 0;
    }
</style>
